<template>
  <div class="bg-base-200 relative flex items-center gap-4 p-2">
    <button class="btn btn-square btn-ghost" @click="toggleMenu">
      <FontAwesomeIcon :icon="faBars" class="text-2xl" />
    </button>
    <div
      class="hidden grow overflow-hidden text-ellipsis whitespace-nowrap lg:block"
      v-if="$t(`routes.${route.name?.toString()}.title`)"
    >
      {{ $t(`routes.${route.name?.toString()}.title`) }}
    </div>
    <RouterView name="navbar" v-slot="{ Component }">
      <component v-if="Component" :is="Component" class="grow basis-0" />
      <DefaultNavbar v-else class="grow basis-0" />
    </RouterView>
    <UpdateAvailableButton />
    <div class="hidden md:flex">
      <InternalLedgerSessionStatusIndicator
        v-if="
          currentSource?.availableTransactionTypes.includes(
            OfferTransactionType.INTERNAL_LEDGER_CASH,
          )
        "
        class="mr-2"
      />
      <CurrentSourceInfo
        :trigger-class="[
          'btn btn-neutral data-[state=\'closed\']:btn-ghost data-[state=\'closed\']:not-hover:not-focus:not-active:text-base-content',
          isPosMode ? 'px-1' : 'px-0',
        ]"
      />
      <div class="divider divider-horizontal m-0" />
      <CurrentUserInfo class="mr-4" />
    </div>
    <progress
      v-show="busy"
      class="progress progress-primary absolute -bottom-2 left-0 h-2 w-full rounded-none"
    />
  </div>
</template>

<script setup lang="ts">
import { useNavigationMenu } from '@/composables/useNavigationMenu';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { OfferTransactionType } from '@konsolenkost-de/acquisition_store_server_sdk_vue';
import { useRoute } from 'vue-router';
import UpdateAvailableButton from '../components/app/UpdateAvailableButton.vue';
import InternalLedgerSessionStatusIndicator from '../components/internal-ledger/InternalLedgerSessionStatusIndicator.vue';
import CurrentSourceInfo from '../components/source/CurrentSourceInfo.vue';
import CurrentUserInfo from '../components/user/CurrentUserInfo.vue';
import { useLoading } from '../stores/loadingStore';
import { usePos } from '../stores/posStore.ts';
import { useSource } from '../stores/sourceStore';
import DefaultNavbar from '../views/navbar/DefaultNavbar.vue';

const { toggleMenu } = useNavigationMenu();
const { busy } = useLoading();
const route = useRoute();
const { currentSource } = useSource();
const { isPosMode } = usePos();
</script>
